import React, { useState } from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import moment from 'moment';
import { useStoreState, useStoreActions } from 'easy-peasy';
import { Link } from 'react-router-dom'

import PerfectScrollbar from 'react-perfect-scrollbar';
import { makeStyles } from '@material-ui/styles';
import {
  Card,
  CardActions,
  CardContent,
  Avatar,
  Checkbox,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
  TablePagination
} from '@material-ui/core';

import { getInitials } from 'helpers';

const useStyles = makeStyles(theme => ({
  root: {},
  content: {
    padding: 0
  },
  inner: {
    minWidth: 1050
  },
  nameContainer: {
    display: 'flex',
    alignItems: 'center'
  },
  avatar: {
    marginRight: theme.spacing(2)
  },
  actions: {
    justifyContent: 'flex-end'
  }
}));

const UsersTable = props => {
  const addToCart = useStoreActions(actions => actions.data.setSelected);
  const dataInCart = useStoreState(state => state.data.selected || []);
  const experimentList = useStoreState(state => state.data.added);

  const { className, users, ...rest } = props;
  const classes = useStyles();

  let [selectedUsers, setSelectedUsers] = useState(dataInCart);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [page, setPage] = useState(0);

  const handleSelectAll = event => {
    const { users } = props;

    let selectedUsers;

    if (event.target.checked) {
      // selectedUsers = users.map(user => user._id);
      selectedUsers = users;
      const mergedList = dataInCart.concat(selectedUsers);
      const noDuplicatesList = mergedList.filter((item, pos) => mergedList.indexOf(item) === pos)
      addToCart(noDuplicatesList);
      // addToCart(selectedUsers);
      setSelectedUsers(selectedUsers);
    } else {
      let afterRemovingExisting = dataInCart.filter(d => users.map(x => x._id).indexOf(d._id) === -1);
      addToCart(afterRemovingExisting); 
      setSelectedUsers([]);
    }
  };

  const handleSelectOne = (event, _id) => {
    const experimentIds = selectedUsers.map(d => d._id);
    const selectedIndex = experimentIds.indexOf(_id);
    let newSelectedUsers = [];
    let experiments = [];


    if (selectedIndex === -1) {
      newSelectedUsers = newSelectedUsers.concat(experimentIds, _id);
    } else if (selectedIndex === 0) {
      newSelectedUsers = newSelectedUsers.concat(experimentIds.slice(1));
    } else if (selectedIndex === experimentIds.length - 1) {
      newSelectedUsers = newSelectedUsers.concat(experimentIds.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelectedUsers = newSelectedUsers.splice(selectedIndex, 1);
    }
    experiments = experimentList.filter(d => newSelectedUsers.indexOf(d._id) > -1);
    // console.log(experiments);
    // console.log([...new Set([...dataInCart, ...experiments])]);
    // addToCart(experiments);
    const mergedList = dataInCart.concat(experiments);
    const noDuplicatesList = mergedList.filter((item, pos) => mergedList.indexOf(item) === pos)

    if (event.target.checked) {
      addToCart(noDuplicatesList);
      setSelectedUsers(experiments);
    } else {
      addToCart(noDuplicatesList.filter(d => d._id !== _id));
      setSelectedUsers(selectedUsers.filter(d => d._id !== _id));
    }

    // addToCart(noDuplicatesList);
    // setSelectedUsers(experiments);

  };

  const handlePageChange = (event, page) => {
    setPage(page);
  };

  const handleRowsPerPageChange = event => {
    setRowsPerPage(event.target.value);
  };

  return (
    <Card
      {...rest}
      className={clsx(classes.root, className)}
    >
      <CardContent className={classes.content}>
        <PerfectScrollbar>
          <div className={classes.inner}>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell padding="checkbox">
                    <Checkbox
                      checked={users.filter(user => selectedUsers.map(d => d._id).indexOf(user._id) !== -1).length}
                      color="primary"
                      indeterminate={
                        selectedUsers.length > 0 &&
                        selectedUsers.length < users.length
                      }
                      onChange={handleSelectAll}
                    />
                  </TableCell>
                  <TableCell>Accession</TableCell>
                  {/* <TableCell>Tissue</TableCell> */}
                  <TableCell>Assay</TableCell>
                  <TableCell>Condition</TableCell>
                  <TableCell>Lab</TableCell>
                  {/* <TableCell>Age</TableCell> */}
                </TableRow>
              </TableHead>
              <TableBody>
                {users.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map(user => (
                  <TableRow
                    className={classes.tableRow}
                    hover
                    key={user._id}
                    selected={selectedUsers.map(d => d._id).indexOf(user._id) !== -1}
                  >
                    <TableCell padding="checkbox">
                      <Checkbox
                        checked={selectedUsers.map(d => d._id).indexOf(user._id) !== -1}
                        color="primary"
                        onChange={event => handleSelectOne(event, user._id)}
                        value="true"
                      />
                    </TableCell>
                    <TableCell>
                      <div className={classes.nameContainer}>
                      {user._id}
                      {/* <Link to={`/experiment/${user._id}`}>
                        <Typography variant="overline">{user._id}</Typography>
                      </Link> */}
                      </div>
                    </TableCell>
                    {/* <TableCell>{user.Tissue}</TableCell> */}
                    <TableCell>
                      {/* {user.address.city}, {user.address.state},{' '}
                      {user.address.country} */}
                      {user.Assay}
                    </TableCell>
                    <TableCell>{user.Condition}</TableCell>
                    <TableCell>{user.Lab}</TableCell>
                    {/* <TableCell>
                      {user.Age}
                      {/* {moment(user.createdAt).format('DD/MM/YYYY')} 
                    </TableCell> */}
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </div>
        </PerfectScrollbar>
      </CardContent>
      <CardActions className={classes.actions}>
        <TablePagination
          component="div"
          count={users.length}
          onChangePage={handlePageChange}
          onChangeRowsPerPage={handleRowsPerPageChange}
          page={page}
          rowsPerPage={rowsPerPage}
          rowsPerPageOptions={[5, 10, 25]}
        />
      </CardActions>
    </Card>
  );
};

UsersTable.propTypes = {
  className: PropTypes.string,
  users: PropTypes.array.isRequired
};

export default UsersTable;
